import {
  Type,
  Menu,
  CheckSquare,
  Copy,
  Search,
  Image,
  FileText,
  MoreVertical,
  ChevronDown,
  X,
} from "lucide-react";
import folderImg from "../../../assets/folderImage.svg";
import React, { useState } from "react";
import CustomizationPanel from "./CustomizationPanel";
import FormCanvas from "./FormCanvas";
import { useDispatch, useSelector } from "react-redux";
import { addForm } from "../../../store/formsSlice";
import RegistrationForm from "./RegistrationForm";

const pendingSuppliers = [
  {
    id: 1,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "In Progress",
  },
  {
    id: 2,
    name: "Jane Doe",
    company: "Apple",
    date: "Mar 16, 2025, 11:15 AM",
    status: "In Progress",
  },
];

const postSuppliers = [
  {
    id: 1,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
  {
    id: 2,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
  {
    id: 3,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
];

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(
    () => {
      console.log("Copied:", text);
    },
    (err) => {
      console.error("Failed to copy:", err);
    }
  );
};

const EmptyState = ({ setActiveTab }) => (
  <div className="flex flex-col items-center justify-start text-center mt-36">
    <div className="flex justify-center items-center mb-6">
      <img src={folderImg} alt="Folder" width={163} length={163} />
    </div>

    <h3 className="text-lg font-medium text-gray-900 mb-2">
      You currently have no active forms
    </h3>
    <p className="text-gray-600 mb-4">You're yet to create a form</p>
    <button
      onClick={() => setActiveTab("create")}
      className="px-6 py-2 bg-[#EAF524] text-black font-medium rounded-md ''"
    >
      Create a Form
    </button>
  </div>
);

const CompletedForms = ({ forms, onOpenForm }) => (
  <div className="min-h-screen p-6">
    {/* Search Bar Section */}
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2">
        <div className="relative">
          <input
            type="text"
            placeholder="Search"
            className="w-[400px] pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
        </div>
        <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium">
          Search
        </button>
      </div>

      <div className="flex items-center gap-4">
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
          <span className="text-gray-700">All</span>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </button>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M5 19H7C7.28333 19 7.52083 19.0958 7.7125 19.2875C7.90417 19.4792 8 19.7167 8 20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H4C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16C4.28333 16 4.52083 16.0958 4.7125 16.2875C4.90417 16.4792 5 16.7167 5 17V19ZM19 19V17C19 16.7167 19.0958 16.4792 19.2875 16.2875C19.4792 16.0958 19.7167 16 20 16C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21H17C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20C16 19.7167 16.0958 19.4792 16.2875 19.2875C16.4792 19.0958 16.7167 19 17 19H19ZM5 5V7C5 7.28333 4.90417 7.52083 4.7125 7.7125C4.52083 7.90417 4.28333 8 4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7V4C3 3.71667 3.09583 3.47917 3.2875 3.2875C3.47917 3.09583 3.71667 3 4 3H7C7.28333 3 7.52083 3.09583 7.7125 3.2875C7.90417 3.47917 8 3.71667 8 4C8 4.28333 7.90417 4.52083 7.7125 4.7125C7.52083 4.90417 7.28333 5 7 5H5ZM19 5H17C16.7167 5 16.4792 4.90417 16.2875 4.7125C16.0958 4.52083 16 4.28333 16 4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8C19.7167 8 19.4792 7.90417 19.2875 7.7125C19.0958 7.52083 19 7.28333 19 7V5Z"
            fill="#1D2739"
          />
        </svg>
      </div>
    </div>

    {/* Table Section */}
    <div className="bg-white rounded-lg shadow overflow-hidden">
      {/* Table Header */}
      <div className="bg-[#F7F7F7] px-6 py-3">
        <div className="grid grid-cols-[2.5fr_2.5fr_4fr_1fr] text-base text-[#1D2739] items-center">
          <div className="text-left">Title</div>
          <div className="text-left">Created</div>
          <div className="text-left">Private URL</div>
          <div className="text-left"></div>
        </div>
      </div>

      {/* Table Rows */}
      {forms.map((form) => (
        <div
          key={form.id}
          className="px-6 py-4 border-b border-gray-200 hover:bg-gray-50"
        >
<div className="grid grid-cols-[2.5fr_2.5fr_4fr_1fr] items-center gap-4">
  <div className="text-left text-gray-900 text-sm">{form.title}</div>
  <div className="text-left text-gray-600 text-sm">{form.created}</div>

  <div className="text-left text-[#0088FF] text-sm flex items-center gap-2 overflow-hidden">
    <a
      href={form.privateUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="truncate max-w-full"
      title={form.privateUrl}
    >
      {form.privateUrl.length > 75
        ? `${form.privateUrl.slice(0, 75)}...`
        : form.privateUrl}
    </a>
    <Copy
      onClick={() => copyToClipboard(form.privateUrl)}
      className="w-5 h-5 cursor-pointer hover:text-gray-600"
    />
  </div>

  <div className="text-left flex justify-end">
    <button className="p-1 hover:bg-gray-100 rounded transition-colors">
      <MoreVertical className="w-5 h-5 text-gray-600" />
    </button>
  </div>
</div>


        </div>
      ))}
    </div>
  </div>
);

const PreviewModal = ({ open, onClose, title, fields }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      style={{ zIndex: 10000 }}
    >
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl px-6 py-12 relative max-h-[85vh] overflow-y-auto">
        <div className="flex flex-row justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-800 text-left">
            Supplier Signup
          </h2>

          <button
            onClick={onClose}
            className=" text-gray-500 hover:text-gray-800"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {/* <h2 className="text-xl mb-4 text-left">{title}</h2> */}
        <FormCanvas fields={fields} setFields={() => {}} preview />
        <button
          onClick={() => onClose()}
          className="bg-[#EAF524] px-6 py-2 rounded font-semibold hover:bg-[#d4e100] transition"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default function SupplierRegistration() {
  const [fields, setFields] = useState([]);
  const [activeTab, setActiveTab] = useState("completed");
  const dispatch = useDispatch();
  const forms = useSelector((state) => state.forms.completedForms);
  const [formTitle, setFormTitle] = useState("");
  const [completedForm, setCompletedForm] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [suppliers, setSuppliers] = React.useState(postSuppliers);
  const [openedForm, setOpenedForm] = useState(null);
  const buyerId = useSelector((state) => state.auth.id);
  const categories = [
    {
      title: "Procurement & Supply Chain Management Organizations",
      options: [
        "American Purchasing Society (APS)",
        "Asia Pacific Procurement Confederation (APPC)",
        "Association for Supply Chain Management (ASCM)",
        "Australian Procurement and Construction Council (APCC)",
        "Canadian Public Procurement Council (CPPC)",
        "Chartered Institute of Procurement & Supply (CIPS)",
        "European Institute of Purchasing Management (EIPM)",
        "Institute for Supply Management (ISM)",
        "Institute of Supply Chain Management (IoSCM)",
        "International Association of Procurement Professionals (IAPP)",
        "International Federation of Purchasing and Supply Management (IFPSM)",
        "National Association of Educational Procurement (NAEP)",
        "National Institute of Governmental Purchasing (NIGP)",
        "Next Level Purchasing Association (NLPA)",
        "Procurement and Supply Chain Management Association of the Philippines (PASIA)",
        "Procurement Leaders",
        "Supply Chain Canada",
      ],
    },
    {
      title: "Government & Public Procurement Organizations",
      options: [
        "Institute for Public Procurement (NIGP)",
        "Institute of Governmental Purchasing (IGP)",
        "Higher Education",
        "National Association of State Procurement Officials (NASPO)",
        "National Procurement Institute (NPI)",
        "The Universal Public Procurement Certification Council (UPPCC)",
      ],
    },
    {
      title: "Contracting & Sourcing Organizations",
      options: [
        "Global Sourcing Association (GSA)",
        "International Association for Contract and Commercial Management (IACCM)",
        "National Contract Management Association (NCMA)",
        "World Commerce & Contracting (WorldCC)",
      ],
    },
    {
      title: "Small Business & Minority Business Organizations",
      options: [
        "Minority Business Development Agency (MBDA)",
        "National Association of Minority Contractors (NAMC)",
        "National Association of Small Business Contractors (NASBC)",
        "National Association of Women Business Owners (NAWBO)",
        "National Black Chamber of Commerce (NBCC)",
        "National Center for American Indian Enterprise Development (NCAIED)",
        "National Women Business Owners Corporation (NWBOC)",
        "U.S. Pan Asian American Chamber of Commerce (USPAACC)",
        "U.S. Small Business Administration (SBA)",
        "United States Hispanic Chamber of Commerce (USHCC)",
        "Asian/Pacific Islander American Chamber of Commerce & Entrepreneurship (ACE)",
      ],
    },
    {
      title: "State-Level Government & Administrative Organizations",
      options: [
        "National Association of State Auditors, Comptrollers and Treasurers (NASACT)",
        "National Association of State Budget Officers (NASBO)",
        "National Association of State Chief Administrators (NASCA)",
        "National Association of State Chief Information Officers (NASCIO)",
        "National Association of State Facilities Administrators (NASFA)",
        "National Association of State Personnel Executives (NASPE)",
        "National Association of State Technology Directors (NASTD)",
        "National Association of State Treasurers (NAST)",
        "National Association of State Workforce Agencies (NASWA)",
        "National Association of State Agencies for Surplus Property (NASASP)",
      ],
    },
    {
      title: "Logistics & Financial Infrastructure",
      options: [
        "International Warehouse Logistics Association (IWLA)",
        "Society for Worldwide Interbank Financial Telecommunication (SWIFT)",
      ],
    },
  ];
  const defaultFormSchema = [
    {
      key: "personalInfo",
      title: "Step 1",
      subtitle: "Personal Details",
      fields: [
        {
          label: "Profile Picture",
          type: "file",
          value: "",
          name: "profilePicture",
        },
        { label: "First Name", type: "text", value: "", name: "firstName" },
        { label: "Last Name", type: "text", value: "", name: "lastName" },
        {
          label: "Country",
          type: "select",
          value: "",
          name: "country",
          options: ["United States", "Canada"],
        },
        {
          label: "State/Province",
          type: "select",
          value: "",
          name: "stateProvince",
          options: [],
        },
        { label: "City", type: "text", value: "", name: "city" },
        {
          label: "Personal Details",
          type: "textarea",
          value: "",
          name: "personalDetails",
        },
        { label: "Phone", type: "text", value: "", name: "phone" },
      ],
    },
    {
      key: "basicInfo",
      title: "Step 2",
      subtitle: "Basic Supplier Information",
      fields: [
        { label: "Company Name", type: "text", value: "", name: "name" },
        {
          label: "Business Legal Name",
          type: "text",
          value: "",
          name: "legalName",
        },
        { label: "DBA Name", type: "text", value: "", name: "dba" },
        {
          label: "Business Description",
          type: "textarea",
          value: "",
          name: "description",
        },
        {
          label: "Business Phone",
          type: "text",
          value: "",
          name: "businessPhone",
        },
        { label: "Website URL", type: "text", value: "", name: "website" },
        {
          label: "Year Registered",
          type: "text",
          value: "",
          name: "foundedYear",
        },
      ],
    },
    {
      key: "businessLocation",
      title: "Step 3",
      subtitle: "Business Location",
      fields: [
        {
          label: "Country",
          type: "select",
          value: "",
          name: "country",
          options: ["United States", "Canada"],
        },
        { label: "Address", type: "text", value: "", name: "address" },
        { label: "City", type: "text", value: "", name: "city" },
        {
          label: "State/Province",
          type: "select",
          value: "",
          name: "stateProvince",
          options: [],
        },
        {
          label: "ZIP / Postal Code",
          type: "text",
          value: "",
          name: "postalCode",
        },
      ],
    },
    {
      key: "registrationCompliance",
      title: "Step 4",
      subtitle: "Registration and Compliance",
      fields: [
        { label: "Tax ID / EIN", type: "text", value: "", name: "ein" },
        { label: "DUNS Number", type: "text", value: "", name: "duns" },
        { label: "CAGE Code", type: "text", value: "", name: "cage" },
        {
          label: "Business Entity Type",
          type: "select",
          value: "",
          name: "entityType",
          options: [
            "Sole Proprietorship",
            "LLC",
            "Corporation",
            "Partnership",
            "Nonprofit Organization",
          ],
        },
        {
          label: "Verification Document",
          type: "file",
          value: "",
          name: "file",
        },
      ],
    },
    {
      key: "servicesCapabilities",
      title: "Step 5",
      subtitle: "Services & Capabilities",
      fields: [
        {
          label: "Industry",
          type: "select",
          value: "",
          name: "industry",
          options: [],
        },
        {
          label: "Primary NAICS",
          type: "select",
          value: "",
          name: "primaryNAICS",
          options: [],
        },
        {
          label: "Additional NAICS",
          type: "multiselect",
          value: [],
          name: "additionalNAICS",
          options: [],
        },
      ],
    },
    {
      key: "diversityVerification",
      title: "Step 6",
      subtitle: "Diversity Data & Verification",
      fields: [
        {
          label: "Diversity Status",
          type: "select",
          value: "",
          name: "diversityStatus",
          options: [],
        },
        { label: "Certifying Agency", type: "text", value: "", name: "agency" },
        { label: "Certification ID", type: "text", value: "", name: "certId" },
        {
          label: "Diversity Certification Document",
          type: "file",
          value: "",
          name: "file",
        },
      ],
    },
    {
      key: "testimonialsReferences",
      title: "Step 7",
      subtitle: "Testimonials & References",
      fields: [
        {
          label: "Type",
          type: "radio",
          value: "Client",
          name: "type",
          options: ["Client", "Professional References"],
        },
        { label: "Name", type: "text", value: "", name: "name" },
        {
          label: "Feedback / Contact Info",
          type: "textarea",
          value: "",
          name: "feedbackOrContact",
        },
        { label: "Uploaded Document", type: "file", value: "", name: "file" },
      ],
    },
    {
      key: "membershipsCertifications",
      title: "Step 8",
      subtitle: "Membership Associations & Certifications",
      fields: [
        {
          label: "Membership Associations",
          type: "multiselect",
          value: [],
          name: "memberships",
          options: categories.map((category) => ({
            label: category.title,
            options: category.options.map((option) => ({
              label: option,
              value: option,
            })),
          })),
        },
        {
          label: "Supplier Certifications",
          type: "multiselect",
          value: [],
          name: "certifications",
          options: [], // you can fill this with certification options
        },
      ],
    },
  ];

  const handleStatusChange = (id, newStatus) => {
    setSuppliers((prev) =>
      prev.map((supplier) =>
        supplier.id === id ? { ...supplier, status: newStatus } : supplier
      )
    );
  };

const generateKeys = () => {
  let baseUrl;

  const host = window.location.hostname;

  if (host.includes("localhost")) {
    baseUrl = "http://localhost:3000";
  } else if (host.includes("testing")) {
    baseUrl = "https://source-iq-frontend-testing-e8b0dkazejabd0b2.eastus-01.azurewebsites.net";
  } else {
    baseUrl = "https://sourceiq.cloud";
  }

  const privateUrl = `${baseUrl}/supplier-profile-registration/personal-details?buyerId=${buyerId}`;
  return { privateUrl };
};


  const handlePreview = () => {
    setShowPreview(true);
  };
  const handleSave = () => {
    const newDraft = {
      id: Date.now(),
      title: formTitle || "Untitled Form",
      fields,
      savedAt: new Date().toLocaleString(),
    };

    setActiveTab("drafts");
  };

  const handleExport = () => {
    const { privateUrl } = generateKeys();
    const newForm = {
      id: Date.now(),
      title: formTitle,
      created: new Date().toLocaleString(),
      privateUrl,
    };

    setCompletedForm(newForm);
    setActiveTab("completed");
  };

  const handleCreate = () => {
    // if (!formTitle.trim()) return;
    const { privateUrl } = generateKeys();
    const newForm = {
      id: Date.now(),
      title: formTitle,
      created: new Date().toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }),
      privateUrl,
      fields: defaultFormSchema,
    };
    dispatch(addForm(newForm));
    setCompletedForm(newForm);
    setFields([]);
    setFormTitle("");
  };
  const contentTypes = [
    { id: "h1", name: "Heading 1", icon: "H1", type: "Heading1" },
    { id: "h2", name: "Heading 2", icon: "H2", type: "Heading2" },
    { id: "body", name: "Body", icon: "B", type: "Body" },
  ];

  const inputTypes = [
    { id: "text", name: "Text Field", icon: Type, type: "TextField" },
    { id: "dropdown", name: "Dropdown", icon: Menu, type: "Dropdown" },
    { id: "checkbox", name: "Checkbox", icon: CheckSquare, type: "Checkbox" },
  ];

  const mediaTypes = [
    { id: "logo", name: "Upload Logo", icon: Image, type: "UploadLogo" },
    { id: "file", name: "Upload File", icon: FileText, type: "UploadFile" },
  ];

  const addField = (type) => {
    const base = {
      id: Date.now(),
      type: type.type,
      label: type.name,
      required: false,
    };
    let newField = { ...base };
    if (type.type === "TextField") newField.placeholder = "";
    if (type.type === "Dropdown" || type.type === "Checkbox")
      newField.options = ["Option 1", "Option 2"];
    if (type.type === "UploadFile" || type.type === "UploadLogo")
      newField.fileName = "";
    setFields([...fields, newField]);
  };

  return (
    <>
      {/* Header + Tabs */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-2xl font-medium text-[#1D2739] py-6 text-left mt-2">
            Supplier Registration
          </h1>
          <nav className="flex space-x-8">
            <button
              onClick={() => setActiveTab("completed")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "completed"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Completed Forms
            </button>
            {/* <button
              onClick={() => setActiveTab("pending")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "pending"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Pending Registration
            </button> */}
            <button
              onClick={() => setActiveTab("post")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "post"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Post Registration
            </button>
            <button
              onClick={() => setActiveTab("create")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "create"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Create a Form
            </button>
          </nav>
        </div>
      </div>

      {/* Top-level layout */}
      <div className="flex bg-white">
        {/* Sidebar */}
        {/* <CustomizationPanel
          addField={addField}
          contentTypes={contentTypes}
          inputTypes={inputTypes}
          mediaTypes={mediaTypes}
        /> */}

        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-y-auto">
          <div className="flex-1 overflow-y-auto">
            {activeTab === "completed" &&
              (forms.length > 0 ? (
                // <CompletedForms forms={forms} />
                <CompletedForms
                  forms={forms}
                  onOpenForm={(form) => setOpenedForm(form)}
                />
              ) : (
                <EmptyState setActiveTab={setActiveTab} />
              ))}

            {activeTab === "create" && !completedForm && (
              <RegistrationForm handleCreate={handleCreate} setFormTitle={setFormTitle} />
              // <div className="flex-1 p-6 overflow-y-auto">
              //   {fields.length > 0 && (
              //     <>
              //       <div className="flex items-center justify-between mb-6">
              //         <h2 className="text-[#7B7B7B] text-sm flex flex-row justify-start items-center">
              //           <svg
              //             xmlns="http://www.w3.org/2000/svg"
              //             width="17"
              //             height="10"
              //             viewBox="0 0 17 10"
              //             fill="none"
              //             className="mr-2"
              //           >
              //             <path
              //               d="M2.25948 5.65501L5.51668 8.88645C5.64963 9.01834 5.71345 9.17222 5.70813 9.34808C5.70281 9.52394 5.63346 9.67782 5.50007 9.80972C5.36712 9.93062 5.21201 9.99393 5.03475 9.99965C4.85749 10.0054 4.70238 9.94205 4.56944 9.80972L0.182178 5.45717C0.115705 5.39122 0.0685086 5.31978 0.0405897 5.24284C0.0126708 5.1659 -0.000845407 5.08347 4.09071e-05 4.99554C4.09071e-05 4.90761 0.0140002 4.82517 0.0419191 4.74823C0.069838 4.67129 0.116591 4.59985 0.182178 4.5339L4.56944 0.181356C4.6913 0.0604518 4.84375 0 5.02677 0C5.2098 0 5.36756 0.0604518 5.50007 0.181356C5.63301 0.313251 5.69949 0.469987 5.69949 0.651563C5.69949 0.833139 5.63301 0.989655 5.50007 1.12111L2.25948 4.33606H16.3353C16.5236 4.33606 16.6816 4.39937 16.8092 4.52599C16.9368 4.65261 17.0004 4.80912 17 4.99554C17 5.18239 16.9362 5.33912 16.8086 5.46574C16.6809 5.59236 16.5232 5.65545 16.3353 5.65501H2.25948Z"
              //               fill="#7B7B7B"
              //             />
              //           </svg>
              //           Return to Form Selection
              //         </h2>
              //         <div className="flex gap-3">
              //           <button
              //             onClick={handleSave}
              //             className="px-4 py-2 bg-[#F1F1F1] text-gray-700 rounded-lg hover:bg-gray-300"
              //           >
              //             Save
              //           </button>
              //           <button
              //             onClick={handlePreview}
              //             className="px-4 py-2 bg-[#F1F1F1] text-gray-700 rounded-lg hover:bg-gray-300"
              //           >
              //             Preview
              //           </button>
              //           <button
              //             onClick={handleExport}
              //             className="px-4 py-2 bg-[#EAF524] text-gray-700 rounded-lg hover:bg-gray-300"
              //           >
              //             Export
              //           </button>
              //         </div>
              //       </div>

              //       <h2 className="text-2xl font-semibold text-gray-800 text-left mb-6">
              //         Supplier Signup
              //       </h2>

              //       {/* Form Title Input */}
              //       <div className="mb-6">
              //         <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
              //           Form Title<span className="text-red-500">*</span>
              //         </label>
              //         <input
              //           type="text"
              //           value={formTitle}
              //           onChange={(e) => setFormTitle(e.target.value)}
              //           placeholder="Enter form title"
              //           className="w-full border px-3 py-2 rounded text-sm bg-[#F9F9F9]"
              //         />
              //       </div>
              //     </>
              //   )}

              //   {/* Form Canvas */}
              //   {fields.length === 0 ? (
              //     <div className="text-center text-gray-500">
              //       <div className="flex items-center justify-center h-64 mt-36">
              //         <div className="text-center">
              //           <div className="flex justify-center items-center mb-4">
              //             <img src={folderImg} alt="Folder" />
              //           </div>
              //           <h2 className="text-lg font-semibold text-gray-700">
              //             Blank Form
              //           </h2>
              //           <p className="text-sm text-gray-500">
              //             Begin building your custom form
              //           </p>
              //         </div>
              //       </div>
              //     </div>
              //   ) : (
              //     <FormCanvas
              //       fields={fields}
              //       setFields={setFields}
              //       preview={showPreview}
              //     />
              //   )}

              //   {fields.length > 0 && (
              //     <button
              //       onClick={handleCreate}
              //       disabled={!formTitle.trim()}
              //       className={`py-4 px-32 rounded-lg mb-12 mt-8 ${
              //         formTitle.trim()
              //           ? "bg-[#EAF524] text-black cursor-pointer"
              //           : "bg-gray-300 text-gray-500 cursor-not-allowed"
              //       }`}
              //     >
              //       Create
              //     </button>
              //   )}
              // </div>
            )}

            {completedForm && activeTab === "create" && (
              <div className="flex flex-col items-center justify-start h-full p-10 text-center relative">
                {/* Top-left back link */}
                <button
                  onClick={() => {
                    setCompletedForm(null);
                    setActiveTab("create");
                  }}
                  className="absolute top-4 left-4 flex items-center text-gray-400 hover:text-gray-600 font-medium"
                >
                  <span className="mr-2">&larr;</span> Go Back
                </button>

                {/* Centered SVG */}
                <div className="mb-6 mt-32">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="188"
                    height="188"
                    viewBox="0 0 188 188"
                    fill="none"
                  >
                    <path
                      d="M94 11.75C115.814 11.75 136.735 20.4156 152.16 35.8405C167.584 51.2653 176.25 72.1859 176.25 94C176.25 115.814 167.584 136.735 152.16 152.16C136.735 167.584 115.814 176.25 94 176.25C72.1859 176.25 51.2653 167.584 35.8405 152.16C20.4156 136.735 11.75 115.814 11.75 94C11.75 72.1859 20.4156 51.2653 35.8405 35.8405C51.2653 20.4156 72.1859 11.75 94 11.75ZM83.754 110.227L65.4827 91.9437C64.8277 91.2887 64.0501 90.7691 63.1943 90.4146C62.3385 90.0602 61.4212 89.8777 60.4949 89.8777C59.5685 89.8777 58.6513 90.0602 57.7955 90.4146C56.9396 90.7691 56.162 91.2887 55.507 91.9437C54.1841 93.2666 53.441 95.0608 53.441 96.9316C53.441 98.8024 54.1841 100.597 55.507 101.919L78.772 125.185C79.4251 125.843 80.2022 126.365 81.0582 126.722C81.9143 127.079 82.8325 127.262 83.7599 127.262C84.6872 127.262 85.6054 127.079 86.4615 126.722C87.3176 126.365 88.0946 125.843 88.7477 125.185L136.923 76.9977C137.587 76.3454 138.115 75.5682 138.476 74.7108C138.838 73.8534 139.027 72.9328 139.031 72.0022C139.036 71.0716 138.856 70.1493 138.502 69.2886C138.148 68.4278 137.627 67.6457 136.969 66.9872C136.312 66.3288 135.53 65.8071 134.67 65.4522C133.809 65.0973 132.887 64.9162 131.957 64.9195C131.026 64.9227 130.105 65.1101 129.248 65.471C128.39 65.8319 127.612 66.359 126.959 67.022L83.754 110.227Z"
                      fill="black"
                    />
                  </svg>
                </div>

                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-800 mb-6">
                  Registration Flow Created
                </h2>

                {/* Private URL */}
                <div className="flex flex-col items-center justify-center mb-6">
                  <span className="text-gray-500 text-sm mb-1">
                    Private URL:
                  </span>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => setOpenedForm(completedForm)}
                      className="underline text-left text-[#0088FF] truncate hover:text-blue-700"
                    >
                      {completedForm.privateUrl}
                    </button>

                    <Copy
                      onClick={() =>
                        copyToClipboard(`https://${completedForm.privateUrl}`)
                      }
                      className="w-5 h-5 text-[#0088FF] cursor-pointer hover:text-blue-600"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* {activeTab === "pending" && (
              <>
                <div className="flex items-center justify-between p-6">
                  <div className="flex items-center gap-2">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search"
                        className="w-[400px] pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                    </div>
                    <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium">
                      Search
                    </button>
                  </div>

                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                      <span className="text-gray-700">All</span>
                      <ChevronDown className="w-4 h-4 text-gray-500" />
                    </button>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 19H7C7.28333 19 7.52083 19.0958 7.7125 19.2875C7.90417 19.4792 8 19.7167 8 20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H4C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16C4.28333 16 4.52083 16.0958 4.7125 16.2875C4.90417 16.4792 5 16.7167 5 17V19ZM19 19V17C19 16.7167 19.0958 16.4792 19.2875 16.2875C19.4792 16.0958 19.7167 16 20 16C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21H17C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20C16 19.7167 16.0958 19.4792 16.2875 19.2875C16.4792 19.0958 16.7167 19 17 19H19ZM5 5V7C5 7.28333 4.90417 7.52083 4.7125 7.7125C4.52083 7.90417 4.28333 8 4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7V4C3 3.71667 3.09583 3.47917 3.2875 3.2875C3.47917 3.09583 3.71667 3 4 3H7C7.28333 3 7.52083 3.09583 7.7125 3.2875C7.90417 3.47917 8 3.71667 8 4C8 4.28333 7.90417 4.52083 7.7125 4.7125C7.52083 4.90417 7.28333 5 7 5H5ZM19 5H17C16.7167 5 16.4792 4.90417 16.2875 4.7125C16.0958 4.52083 16 4.28333 16 4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8C19.7167 8 19.4792 7.90417 19.2875 7.7125C19.0958 7.52083 19 7.28333 19 7V5Z"
                        fill="#1D2739"
                      />
                    </svg>
                  </div>
                </div>
                <div className="bg-white rounded-lg overflow-hidden p-6">

                  <div className="bg-[#F7F7F7] px-6 py-3 border-b">
                    <div className="grid grid-cols-[2fr_2fr_2fr_1fr_0.5fr] text-base text-[#1D2739] items-center">
                      <div className="text-left">Supplier Name</div>
                      <div className="text-left">Company</div>
                      <div className="text-left">Date Submitted</div>
                      <div className="text-left">Status</div>
                      <div className="text-left"></div>
                    </div>
                  </div>


                  {pendingSuppliers.map((supplier) => (
                    <div
                      key={supplier.id}
                      className="px-6 py-4 border-b border-gray-200 hover:bg-gray-50"
                    >
                      <div className="grid grid-cols-[2fr_2fr_2fr_1fr_0.5fr] items-center gap-4">
                   
                        <div className="text-left text-gray-900 text-sm">
                          {supplier.name}
                        </div>

         
                        <div className="text-left text-gray-900 text-sm">
                          {supplier.company}
                        </div>

            
                        <div className="text-left text-gray-600 text-sm">
                          {supplier.date}
                        </div>

   
                        <div className="text-left">
                          <span className="px-3 py-1 text-xs font-medium rounded-full bg-[#FDF4DC] text-[#8A6D1D]">
                            {supplier.status}
                          </span>
                        </div>

       
                        <div className="text-left flex justify-end">
                          <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                            <MoreVertical className="w-5 h-5 text-gray-600" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )} */}

            {activeTab === "post" && (
              <>
                <div className="flex items-center justify-between p-6">
                  <div className="flex items-center gap-2">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search"
                        className="w-[400px] pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                    </div>
                    <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium">
                      Search
                    </button>
                  </div>

                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                      <span className="text-gray-700">All</span>
                      <ChevronDown className="w-4 h-4 text-gray-500" />
                    </button>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 19H7C7.28333 19 7.52083 19.0958 7.7125 19.2875C7.90417 19.4792 8 19.7167 8 20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H4C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16C4.28333 16 4.52083 16.0958 4.7125 16.2875C4.90417 16.4792 5 16.7167 5 17V19ZM19 19V17C19 16.7167 19.0958 16.4792 19.2875 16.2875C19.4792 16.0958 19.7167 16 20 16C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21H17C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20C16 19.7167 16.0958 19.4792 16.2875 19.2875C16.4792 19.0958 16.7167 19 17 19H19ZM5 5V7C5 7.28333 4.90417 7.52083 4.7125 7.7125C4.52083 7.90417 4.28333 8 4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7V4C3 3.71667 3.09583 3.47917 3.2875 3.2875C3.47917 3.09583 3.71667 3 4 3H7C7.28333 3 7.52083 3.09583 7.7125 3.2875C7.90417 3.47917 8 3.71667 8 4C8 4.28333 7.90417 4.52083 7.7125 4.7125C7.52083 4.90417 7.28333 5 7 5H5ZM19 5H17C16.7167 5 16.4792 4.90417 16.2875 4.7125C16.0958 4.52083 16 4.28333 16 4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8C19.7167 8 19.4792 7.90417 19.2875 7.7125C19.0958 7.52083 19 7.28333 19 7V5Z"
                        fill="#1D2739"
                      />
                    </svg>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow overflow-hidden">
                  {/* Table Header */}
                  <div className="bg-[#F7F7F7] px-6 py-3 border-b">
                    <div className="grid grid-cols-[0.5fr_2fr_2fr_2.5fr_3.5fr_0.5fr] text-base text-[#1D2739] items-center">
                      <div></div>
                      <div className="text-left text-sm">Supplier Name</div>
                      <div className="text-left text-sm">Company</div>
                      <div className="text-left text-sm">Date Submitted</div>
                      <div className="text-left whitespace-nowrap text-sm">
                        Document Verification Status
                      </div>
                      <div className="text-left text-sm"></div>
                    </div>
                  </div>

                  {/* Table Rows */}
                  {suppliers.map((supplier) => (
                    <div
                      key={supplier.id}
                      className="px-6 py-4 border-b border-gray-200 hover:bg-gray-50"
                    >
                      <div className="grid grid-cols-[0.5fr_2fr_2fr_2.5fr_3.5fr_0.5fr] items-center gap-4">
                        {/* Supplier Name with checkmark */}
                        <div className="flex items-center text-gray-900 text-sm">
                          {/* <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-black text-white"> */}
                          {supplier.status !== "No Action" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5ZM10.692 14.0715L8.3595 11.7375C8.27588 11.6539 8.17661 11.5876 8.06736 11.5423C7.9581 11.497 7.84101 11.4737 7.72275 11.4737C7.60449 11.4737 7.4874 11.497 7.37814 11.5423C7.26889 11.5876 7.16962 11.6539 7.086 11.7375C6.91712 11.9064 6.82225 12.1354 6.82225 12.3743C6.82225 12.6131 6.91712 12.8421 7.086 13.011L10.056 15.981C10.1394 16.065 10.2386 16.1317 10.3479 16.1773C10.4571 16.2228 10.5744 16.2462 10.6927 16.2462C10.8111 16.2462 10.9284 16.2228 11.0376 16.1773C11.1469 16.1317 11.2461 16.065 11.3295 15.981L17.4795 9.8295C17.5642 9.74623 17.6316 9.647 17.6778 9.53755C17.724 9.42809 17.7481 9.31057 17.7487 9.19177C17.7492 9.07297 17.7262 8.95523 17.6811 8.84535C17.6359 8.73547 17.5694 8.63562 17.4854 8.55156C17.4015 8.46751 17.3017 8.4009 17.1919 8.3556C17.0821 8.31029 16.9644 8.28718 16.8455 8.28759C16.7267 8.288 16.6092 8.31193 16.4997 8.358C16.3902 8.40407 16.2909 8.47136 16.2075 8.556L10.692 14.0715Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </div>
                        <div className="flex items-center gap-2 text-gray-900 text-sm">
                          {supplier.name}
                        </div>

                        <div className="text-left text-gray-900 text-sm">
                          {supplier.company}
                        </div>

                        <div className="text-left text-gray-600 text-sm">
                          {supplier.date}
                        </div>

                        <div className="text-left flex justify-between items-center">
                          <div className="flex">
                            {supplier.status === "Verified" && (
                              <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-600">
                                Verified
                              </span>
                            )}
                            {supplier.status === "Rejected" && (
                              <span className="px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-600">
                                Rejected
                              </span>
                            )}
                            {supplier.status === "No Action" && (
                              <span className="px-3 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-600">
                                No Action
                              </span>
                            )}
                          </div>

                          <div className="flex">
                            <button className="p-1 hover:bg-gray-100 rounded">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M4 20C3.71667 20 3.47917 19.9042 3.2875 19.7125C3.09583 19.5208 3 19.2833 3 19C3 18.7167 3.09583 18.4792 3.2875 18.2875C3.47917 18.0958 3.71667 18 4 18H14C14.2833 18 14.5208 18.0958 14.7125 18.2875C14.9042 18.4792 15 18.7167 15 19C15 19.2833 14.9042 19.5208 14.7125 19.7125C14.5208 19.9042 14.2833 20 14 20H4ZM16 13C14.6167 13 13.4375 12.5125 12.4625 11.5375C11.4875 10.5625 11 9.38333 11 8C11 6.61667 11.4875 5.4375 12.4625 4.4625C13.4375 3.4875 14.6167 3 16 3C17.3833 3 18.5625 3.4875 19.5375 4.4625C20.5125 5.4375 21 6.61667 21 8C21 9.38333 20.5125 10.5625 19.5375 11.5375C18.5625 12.5125 17.3833 13 16 13ZM4 12C3.71667 12 3.47917 11.9042 3.2875 11.7125C3.09583 11.5208 3 11.2833 3 11C3 10.7167 3.09583 10.4792 3.2875 10.2875C3.47917 10.0958 3.71667 10 4 10H8.675C8.95833 10 9.19583 10.0958 9.3875 10.2875C9.57917 10.4792 9.675 10.7167 9.675 11C9.675 11.2667 9.57917 11.5 9.3875 11.7C9.19583 11.9 8.95833 12 8.675 12H4ZM4 16C3.71667 16 3.47917 15.9042 3.2875 15.7125C3.09583 15.5208 3 15.2833 3 15C3 14.7167 3.09583 14.4792 3.2875 14.2875C3.47917 14.0958 3.71667 14 4 14H11.925C12.2083 14 12.4458 14.0958 12.6375 14.2875C12.8292 14.4792 12.925 14.7167 12.925 15C12.925 15.2667 12.8333 15.5 12.65 15.7C12.4667 15.9 12.225 16 11.925 16H4ZM16 11C16.1333 11 16.25 10.95 16.35 10.85C16.45 10.75 16.5 10.6333 16.5 10.5V7.5C16.5 7.36667 16.45 7.25 16.35 7.15C16.25 7.05 16.1333 7 16 7C15.8667 7 15.75 7.05 15.65 7.15C15.55 7.25 15.5 7.36667 15.5 7.5V10.5C15.5 10.6333 15.55 10.75 15.65 10.85C15.75 10.95 15.8667 11 16 11ZM16 6C16.1333 6 16.25 5.95 16.35 5.85C16.45 5.75 16.5 5.63333 16.5 5.5C16.5 5.36667 16.45 5.25 16.35 5.15C16.25 5.05 16.1333 5 16 5C15.8667 5 15.75 5.05 15.65 5.15C15.55 5.25 15.5 5.36667 15.5 5.5C15.5 5.63333 15.55 5.75 15.65 5.85C15.75 5.95 15.8667 6 16 6Z"
                                  fill="#0088FF"
                                />
                              </svg>
                            </button>
                            {/* Approve */}
                            <button
                              className="p-1 hover:bg-gray-100 rounded text-green-600"
                              onClick={() =>
                                handleStatusChange(supplier.id, "Verified")
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                                  fill="#02AD28"
                                />
                              </svg>
                            </button>
                            {/* Reject */}
                            <button
                              className="p-1 hover:bg-gray-100 rounded text-red-600"
                              onClick={() =>
                                handleStatusChange(supplier.id, "Rejected")
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                                  fill="#B53E3E"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="text-left flex justify-end">
                          <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                            <MoreVertical className="w-5 h-5 text-gray-600" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <PreviewModal
        open={showPreview}
        onClose={() => setShowPreview(false)}
        title={formTitle}
        fields={fields}
      />
    </>
  );
}
